export default __webpack_public_path__ + "static/media/active-doctor-task.29d96964.svg";